import React, { memo, useState, useEffect, useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { Sidebar, SidebarProvider } from '@Sage/ssm-web5';
import { connect } from 'react-redux';

import './styles.scss';

function mapStateToProps({ authentication, implementations }) {
    const { canSwitchImpl } = authentication;
    return {
        currentImplementation: implementations.current?.licenseEditionCode,
        parameters: implementations.current?.parameters,
        canSwitchImpl,
    };
}

const Navbar = ({
    impl,
    permissions,
    permissionsLoading,
    navbarOptions = [],
    getNavbarOptions,
    parameters,
    canSwitchImpl,
    productCode,
}) => {
    const location = useLocation();
    const [currentRoute, setCurrentRoute] = useState(location.pathname);
    const currentImpl = useRef();
    const currentProductCode = useRef();

    useEffect(() => {
        if (location.pathname !== currentRoute) {
            setCurrentRoute(location.pathname);
        }
    }, [currentRoute, location]);

    // Empty
    const newSections = useMemo(() => [], []);

    const isSandbox = useMemo(() => parameters?.isSandbox, [parameters]);

    const renderMenuItems = useMemo(() => {
        if (!navbarOptions) {
            return null;
        }

        const menuItems = navbarOptions
            .map((el) => {
                const isNew = newSections.includes(el.section) || false;
                return {
                    ...el,
                    className: el.type === 'link' ? `navbar__menu-item__${el.section}` : undefined,
                    isNew,
                };
            })
            .filter((el) => {
                if (isSandbox) return el.section !== 'sandbox';
                else return true;
            });

        const finalSchema = {
            appName: 'cfm',
            homeLink: canSwitchImpl ? '#/choose' : '#/app/workspace',
            menuItems,
        };

        return finalSchema;
    }, [canSwitchImpl, isSandbox, navbarOptions, newSections]);

    const customLogo = useMemo(
        () => ({
            square: parameters?.customerSidebarLogoSquareUrlWeb,
            rectangular: parameters?.customerSidebarLogoRectangularUrlWeb,
        }),
        [parameters],
    );

    useEffect(() => {
        if (
            permissionsLoading ||
            (currentProductCode.current === productCode &&
                (currentImpl?.current === impl ||
                    (currentImpl.current === 0 && impl === 0) ||
                    parameters))
        )
            return;

        getNavbarOptions(permissions, productCode);

        currentImpl.current = impl;
        currentProductCode.current = productCode;
    }, [
        impl,
        permissions,
        permissionsLoading,
        currentImpl,
        parameters,
        getNavbarOptions,
        productCode,
    ]);

    return (
        <nav className="navbar">
            {parameters && (
                <SidebarProvider>
                    <Sidebar
                        customColor={parameters.brandingWebColor}
                        customLogo={customLogo}
                        schema={renderMenuItems}
                        currentHref={`#${currentRoute}`}
                    />
                </SidebarProvider>
            )}
        </nav>
    );
};

Navbar.propTypes = {
    navbarOptions: PropTypes.arrayOf(PropTypes.shape({})),
    getNavbarOptions: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(memo(Navbar));
